import { render, staticRenderFns } from "./AdminAbout.vue?vue&type=template&id=42fc0e8f&scoped=true&"
import script from "./AdminAbout.vue?vue&type=script&lang=js&"
export * from "./AdminAbout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42fc0e8f",
  null
  
)

export default component.exports